import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Badge from 'components/Badge/Badge';
import { Info } from '@material-ui/icons';
import { Tooltip } from '@mui/material';

const useStyles = makeStyles({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  label: {
    position: 'absolute',
    transform: 'translateY(-13px)',
    padding: '0px 10px',
    borderRadius: 32,
    fontWeight: 'bold',
    padding: '0px 20px',
  },
});

export default function Divider({
  text = undefined,
  mt = 0,
  mb = 0,
  fz = 15,
  color = '#c3c3c3',
  solid = false,
  tooltipTitle = undefined,
}) {
  const classes = useStyles();

  return (
    <div
      className={classes.container}
      style={{
        marginTop: 15 + mt,
        marginBottom: 15 + mb,
        borderTop: `2px solid ${color}`,
      }}
    >
      {text ? (
        <span
          className={classes.label}
          style={{
            fontSize: fz,
            border: `2px solid ${color}`,
            backgroundColor: solid ? color : 'white',
            color: solid ? 'white' : 'black',
            textAlign: 'center',
          }}
        >
          {text}

          {tooltipTitle !== undefined && (
            <Tooltip
              title={tooltipTitle}
              style={{
                display: 'inline-block',
                position: 'relative',
                top: '3px',
                marginLeft: '3px',
              }}
              placement="top-end"
              arrow
            >
              <div>
                <Badge color="info" fz={5} style={{ padding: '0' }}>
                  <Info fontSize="small" />
                </Badge>
              </div>
            </Tooltip>
          )}
        </span>
      ) : undefined}
    </div>
  );
}
